import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { NavigationLoggedOutHomeCardComponent } from './navigation-logged-out-home-components/navigation-logged-out-home-card.component';
import { NavigationLoggedOutHomeListComponent } from './navigation-logged-out-home-components/navigation-logged-out-home-list.component';
import { NavigationLoggedOutHomeNavItemComponent } from './navigation-logged-out-home-components/navigation-logged-out-home-nav-item.component';
import { NavigationLoggedOutHomeMenuComponent } from './navigation-logged-out-home-menu/navigation-logged-out-home-menu.component';
import {
  NavigationLoggedOutHomeSectionFindWorkByLanguagesComponent,
  NavigationLoggedOutHomeSectionFindWorkBySkillsComponent,
  NavigationLoggedOutHomeSectionFindWorkBySkillsListComponent,
  NavigationLoggedOutHomeSectionFindWorkComponent,
} from './navigation-logged-out-home-section/navigation-logged-out-home-section-find-work.component';
import { NavigationLoggedOutHomeSectionGetIdeasComponent } from './navigation-logged-out-home-section/navigation-logged-out-home-section-get-ideas.component';
import {
  NavigationLoggedOutHomeSectionHireFreelancersByLocationComponent,
  NavigationLoggedOutHomeSectionHireFreelancersBySkillsComponent,
  NavigationLoggedOutHomeSectionHireFreelancersBySkillsListComponent,
  NavigationLoggedOutHomeSectionHireFreelancersComponent,
} from './navigation-logged-out-home-section/navigation-logged-out-home-section-hire-freelancers.component';
import { NavigationLoggedOutHomeSectionProductsComponent } from './navigation-logged-out-home-section/navigation-logged-out-home-section-products.component';
import { NavigationLoggedOutHomeSectionResourcesComponent } from './navigation-logged-out-home-section/navigation-logged-out-home-section-resources.component';
import { NavigationLoggedOutHomeSectionServicesComponent } from './navigation-logged-out-home-section/navigation-logged-out-home-section-services.component';
import { NavigationLoggedOutHomeSectionSolutionsComponent } from './navigation-logged-out-home-section/navigation-logged-out-home-section-solutions.component';
import { NavigationLoggedOutHomeComponent } from './navigation-logged-out-home.component';

@NgModule({
  imports: [CommonModule, TrackingModule, UiModule, FeatureFlagsModule],
  declarations: [
    NavigationLoggedOutHomeCardComponent,
    NavigationLoggedOutHomeComponent,
    NavigationLoggedOutHomeMenuComponent,
    NavigationLoggedOutHomeNavItemComponent,
    NavigationLoggedOutHomeSectionHireFreelancersBySkillsComponent,
    NavigationLoggedOutHomeSectionHireFreelancersBySkillsListComponent,
    NavigationLoggedOutHomeSectionHireFreelancersByLocationComponent,
    NavigationLoggedOutHomeSectionHireFreelancersComponent,
    NavigationLoggedOutHomeSectionFindWorkBySkillsComponent,
    NavigationLoggedOutHomeSectionFindWorkBySkillsListComponent,
    NavigationLoggedOutHomeSectionFindWorkByLanguagesComponent,
    NavigationLoggedOutHomeSectionFindWorkComponent,
    NavigationLoggedOutHomeSectionGetIdeasComponent,
    NavigationLoggedOutHomeSectionSolutionsComponent,
    NavigationLoggedOutHomeSectionProductsComponent,
    NavigationLoggedOutHomeSectionResourcesComponent,
    NavigationLoggedOutHomeSectionServicesComponent,
    NavigationLoggedOutHomeListComponent,
  ],
  exports: [
    NavigationLoggedOutHomeCardComponent,
    NavigationLoggedOutHomeComponent,
    NavigationLoggedOutHomeMenuComponent,
    NavigationLoggedOutHomeNavItemComponent,
    NavigationLoggedOutHomeSectionHireFreelancersBySkillsComponent,
    NavigationLoggedOutHomeSectionHireFreelancersBySkillsListComponent,
    NavigationLoggedOutHomeSectionHireFreelancersByLocationComponent,
    NavigationLoggedOutHomeSectionHireFreelancersComponent,
    NavigationLoggedOutHomeSectionFindWorkBySkillsComponent,
    NavigationLoggedOutHomeSectionFindWorkBySkillsListComponent,
    NavigationLoggedOutHomeSectionFindWorkByLanguagesComponent,
    NavigationLoggedOutHomeSectionFindWorkComponent,
    NavigationLoggedOutHomeSectionGetIdeasComponent,
    NavigationLoggedOutHomeSectionSolutionsComponent,
    NavigationLoggedOutHomeSectionProductsComponent,
    NavigationLoggedOutHomeSectionResourcesComponent,
    NavigationLoggedOutHomeSectionServicesComponent,
    NavigationLoggedOutHomeListComponent,
  ],
})
export class NavigationLoggedOutHomeModule {}
